import Resource from '@/api/resources/Resource'

export interface ISampleTypeWorkflow {
    code: string
    translatedName: string
}

class SampleTypeWorkflowsServices extends Resource {
    async getSampleTypeWorkflows(): Promise<Array<ISampleTypeWorkflow>> {
        const response = await this.axios.get(`/common/sampleTypeWorkflows`)
        return response.data
    }
}

export const sampleTypeWorkflowsServices = new SampleTypeWorkflowsServices()
